/** The hero endgame screen */
import kontra from 'kontra';

import BaseScene from './base';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../constants';

const { emit, keyPressed } = kontra;

export default class HeroScene extends BaseScene {
  constructor () {
    super();
    this.outer = document.querySelector('.cowards-death');
    this.button = document.querySelector('.cowards-death .title-screen');
    this.button.addEventListener('click', () => {
      emit('scene-change', 'title');
    });
  }

  onEnter () {
    this.outer.classList.add('visible');
  }

  onExit () {
    this.outer.classList.remove('visible');
  }

  update () {
  }

  render () {
  }
}
